"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryJobs = void 0;
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.parse-float.js");
require("core-js/modules/es.regexp.to-string.js");
var _stringFunctions = require("./stringFunctions");
var _math = require("./math");
var queryJobs = function queryJobs(jobs, term, latitude, longitude, range, searchTargets, units, states, shiftTypes, cities, categories) {
  term = term.toLowerCase();
  term = (0, _stringFunctions.removeAccents)(term);
  if (term.includes('|')) {
    term = term.split('|');
  } // TODO : "and" logic.
  // let and = false;
  // let addAnd = false;
  // if (term.includes( '+' )) {
  //     term = term.split( '+' );
  //     and = true;
  // }

  var tempList = [];
  var allJobs = jobs;
  if (term === '' && !latitude && !longitude && !states) {
    return allJobs;
  }
  for (var job in allJobs) {
    if (allJobs.hasOwnProperty(job)) {
      // If lat/lng is given, check if the job is close enough to show.
      if (latitude && longitude) {
        var userLat = parseFloat(latitude);
        var userLng = parseFloat(longitude);
        if (userLat && userLng) {
          var _allJobs$job, _allJobs$job2;
          if ((_allJobs$job = allJobs[job]) !== null && _allJobs$job !== void 0 && _allJobs$job.lat && (_allJobs$job2 = allJobs[job]) !== null && _allJobs$job2 !== void 0 && _allJobs$job2.lng) {
            var _allJobs$job3, _allJobs$job4;
            var jobLat = parseFloat((_allJobs$job3 = allJobs[job]) === null || _allJobs$job3 === void 0 ? void 0 : _allJobs$job3.lat);
            var jobLng = parseFloat((_allJobs$job4 = allJobs[job]) === null || _allJobs$job4 === void 0 ? void 0 : _allJobs$job4.lng);
            if (!jobLat || !jobLng) continue;
            var dist = (0, _math.distance)(userLat, userLng, jobLat, jobLng, units);
            allJobs[job].distance = dist;
            if (dist > range) {
              continue;
            }
          }
        }
      }
      if (states.length > 0) {
        var addJob = false;
        for (var state in states) {
          var _allJobs$job5;
          if (String((_allJobs$job5 = allJobs[job]) === null || _allJobs$job5 === void 0 ? void 0 : _allJobs$job5.state) === states[state]) addJob = true;
        }
        if (!addJob) continue;
      }
      if (shiftTypes.length > 0) {
        var _addJob = false;
        for (var shift in shiftTypes) {
          var _allJobs$job6;
          if (String((_allJobs$job6 = allJobs[job]) === null || _allJobs$job6 === void 0 ? void 0 : _allJobs$job6.fullTime) === shiftTypes[shift]) _addJob = true;
        }
        if (!_addJob) continue;
      }
      if (categories.length > 0) {
        var _addJob2 = false;
        for (var category in categories) {
          var _allJobs$job7;
          if (String((_allJobs$job7 = allJobs[job]) === null || _allJobs$job7 === void 0 ? void 0 : _allJobs$job7.category) === categories[category]) _addJob2 = true;
        }
        if (!_addJob2) continue;
      }
      if (cities.length > 0) {
        var _addJob3 = false;
        for (var city in cities) {
          var _allJobs$job8;
          if (String((_allJobs$job8 = allJobs[job]) === null || _allJobs$job8 === void 0 ? void 0 : _allJobs$job8.city) === cities[city]) _addJob3 = true;
        }
        if (!_addJob3) continue;
      }
      for (var target in searchTargets) {
        if (allJobs[job].hasOwnProperty(searchTargets[target])) {
          if (typeof term === 'object') {
            for (var t in term) {
              if (term[t] === '') continue;
              if ((0, _stringFunctions.removeAccents)(jobs[job][searchTargets[target]].toString().toLowerCase()).includes(term[t])) {
                tempList.push(allJobs[job]);
                break;
              }
            }
          } else {
            if ((0, _stringFunctions.removeAccents)(allJobs[job][searchTargets[target]].toString().toLowerCase()).includes(term) || term === '') {
              tempList.push(allJobs[job]);
              break;
            }
          }
        }
      }
    }
  }
  return tempList;
};
exports.queryJobs = queryJobs;